import { bind } from 'bind-decorator';
import type { IServiceGraderPool } from '../../interfaces/serviceGraderPoolInterfaces';
import { deleteJson, getJson } from '../../../../../store/fetch';
import { translateKey } from '../../../../../translate';
import {
    AdminTable,
    DangerAlertWhenErrorCode,
    Loader,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from '../../../../elements/common';
import { Component } from '../../../../elements/Component';
import { ServiceGraderPoolListBody } from './ServiceGraderPoolListBody';

interface IServiceGraderPoolListState {
    error: string;
    loading: boolean;
    serviceGraderPools: IServiceGraderPool[];
}

interface IServiceGraderPoolListProps {
    serviceId: string;
}

export class ServiceGraderPoolList extends Component<IServiceGraderPoolListProps, IServiceGraderPoolListState> {
    public state: IServiceGraderPoolListState = {
        loading: true,
        serviceGraderPools: [],
        error: '',
    };

    public async componentDidMount() {
        await this.fetchServiceGraderPools();
    }

    public async componentDidUpdate(prevProps: Readonly<IServiceGraderPoolListProps>) {
        if (prevProps.serviceId !== this.props.serviceId) {
            await this.fetchServiceGraderPools();
        }
    }

    public render() {
        if (this.state.loading) {
            return <Loader />;
        }

        return (
            <AdminTable>
                <TableHead>
                    <TableRow>
                        <TableHeader>{translateKey('serviceGraderPool.name')} </TableHeader>
                        <TableHeader>&nbsp;</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <DangerAlertWhenErrorCode errorCode={this.state.error} />
                    <ServiceGraderPoolListBody
                        onDelete={this.deleteServiceGraderPool}
                        serviceGraderPools={this.state.serviceGraderPools}
                        serviceId={this.props.serviceId}
                    />
                </TableBody>
            </AdminTable>
        );
    }

    private async fetchServiceGraderPools() {
        const url = `/api/serviceGraderPools?serviceId=${this.props.serviceId}`;
        const result = await getJson(url);

        await this.setState({ loading: false, serviceGraderPools: result.json.items });
    }

    @bind
    private async deleteServiceGraderPool(id: string) {
        const url = `/api/serviceGraderPools/${id}`;
        try {
            await deleteJson(url);
            await this.fetchServiceGraderPools();
        } catch (e: any) {
            switch (e.errorCode) {
                case 'STILL_PROVIDERS_ATTACHED':
                case 'STILL_ATTACHED_TO_SERVICEORGANIZATIONSETTINGS':
                    await this.setState({ error: e.errorCode });
                    break;
                default:
                    throw e;
            }
        }
    }
}
